import { useQuery } from '@tanstack/react-query';
import type { Me, PublicSettings, UserSummary } from '@wo/shared';
import { api, ApiError } from './api';

export function useMe() {
  return useQuery({
    queryKey: ['me'],
    queryFn: async () => {
      try {
        return await api.get<Me>('/api/me');
      } catch (e) {
        if (e instanceof ApiError && e.status === 401) return null;
        throw e;
      }
    },
    staleTime: 60_000,
  });
}

export function useSettings(enabled = true) {
  return useQuery({ queryKey: ['settings'], queryFn: () => api.get<PublicSettings>('/api/settings/public'), staleTime: 5 * 60_000, enabled });
}

export function useUsers(enabled = true) {
  return useQuery({ queryKey: ['users'], queryFn: () => api.get<UserSummary[]>('/api/users'), enabled });
}

/** Active mechanics, for assign/reassign pickers. */
export function useMechanics(enabled = true) {
  const q = useUsers(enabled);
  return { ...q, data: q.data?.filter((u) => u.role === 'MECHANIC' && u.active) };
}
